var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.215,11l9.533-9.533A.859.859,0,1,0,20.533.252L11,9.785,1.467.252A.859.859,0,0,0,.251,1.468L9.784,11,.251,20.534a.859.859,0,0,0,1.215,1.215L11,12.216l9.533,9.533a.859.859,0,0,0,1.215-1.215Z",
    transform: "translate(0 -0.001)"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj48cGF0aCBkPSJNMTIuMjE1LDExbDkuNTMzLTkuNTMzQS44NTkuODU5LDAsMSwwLDIwLjUzMy4yNTJMMTEsOS43ODUsMS40NjcuMjUyQS44NTkuODU5LDAsMCwwLC4yNTEsMS40NjhMOS43ODQsMTEsLjI1MSwyMC41MzRhLjg1OS44NTksMCwwLDAsMS4yMTUsMS4yMTVMMTEsMTIuMjE2bDkuNTMzLDkuNTMzYS44NTkuODU5LDAsMCwwLDEuMjE1LTEuMjE1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMC4wMDEpIi8+PC9zdmc+";
export { SvgClose as ReactComponent };